enum HelpType {
  CONTACT_US = "CONTACT_US",
  FAQ = "FAQ",
  HELP_CENTER = "HELP_CENTER",
  PRODUCT_TOUR = "PRODUCT_TOUR",
}

export { HelpType };
